import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/vue-awesome-swiper.js'
// import jstools from 'jstools-common/dist/jstools.web.js'
import App from './App.vue'
import router from './router'
import store from './store'
import xVueUI from '@xue5hen/x-vue-ui/lib/xVueUI.common.js'
import '@xue5hen/x-vue-ui/lib/xVueUI.css'
import './assets/styles/index.less'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/ttf/ttf.less'


Vue.config.productionTip = false
// Vue.prototype.$jstools = jstools
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ElementUI);
Vue.use(xVueUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
